import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { singleAlphabet } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedApeironFields = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    let schema = {
        ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
        license_plate: yup.string().required(),
    };

    if (!legalEntity) {
        schema = {
            ...schema,
            name: singleAlphabet(schema.name),
            surname: singleAlphabet(schema.surname),
        };
    }

    // nationality is shown if not legalEntity
    if (!legalEntity) {
        schema = {
            ...schema,
            nationality: yup.string().required(),
        };
    }

    // Second driver fields, shown when only_driver is false
    schema = {
        ...schema,
        surname2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
        name2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
        tax_no2: yup.string().when('only_driver', {
            is: false,
            then: s => s
                .matches(/^\d+$/, {
                    message: greekMessages.mixed.isValidAFM,
                })
                .length(9, greekMessages.mixed.isValidAFM)
                .required(),
        }),
        nationality2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
        license_cat2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
    };

    return schema;
};


export const sharedApeironSchemaBuilder = (...args) => yup.object(sharedApeironFields(...args));
export default sharedApeironSchemaBuilder;
